import script from "./PrivacyPolicyPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrivacyPolicyPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__